<template>
    <div>
        <div class="q-display-1 q-mb-md">
            <span class="q-headline text-weight-light">{{ $t('redeem_history') }}</span>
        </div>

        <q-table
            :data="redeem_history_list"
            :columns="columns_redeem_history"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            :filter="filter"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
        >

            <template slot="top" slot-scope="props" :props="props">
                <q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />
                <div class="col" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="reward_title" :props="props">
                    {{ props.row.reward_title }}
                </q-td>

                <q-td key="price" :props="props">
                    {{ props.row.price ? Math.round(props.row.price*100)/100 : 0 }}
                </q-td>

                <q-td key="created_date" :props="props">
                    {{ fDate(props.row.created_date) }}
                </q-td>

                <q-td key="updated_date" :props="props">
                    {{ fDate(props.row.updated_date) }}
                </q-td>

                <q-td key="reward_campaign_title" :props="props">
                    {{ props.row.reward_campaign_title }}
                </q-td>

                <q-td key="status" :props="props" auto-width >
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" >
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>
            </q-tr>
        </q-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: ['user_id'],

    data() {
        return {
            id_redeem: '',
            loading: false,
            filter:'',
            redeem_history_list: [],
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns_redeem_history: [
                {
                    name: 'reward_title',
                    required: true,
                    label: 'reward_title',
                    align: 'left',
                    field: 'reward_title',
                    sortable: true,
                },
                {
                    name: 'price',
                    required: true,
                    label: 'price',
                    align: 'left',
                    field: 'price',
                    sortable: true,
                },
                {
                    name: 'created_date',
                    required: true,
                    label: 'registration_date',
                    align: 'left',
                    field: 'created_date',
                    sortable: true,
                },
                {
                    name: 'updated_date',
                    required: true,
                    label: 'updated_date',
                    align: 'left',
                    field: 'updated_date',
                    sortable: true,
                },
                {
                    name: 'reward_campaign_title',
                    required: true,
                    label: 'campaign',
                    align: 'left',
                    field: 'reward_campaign_title',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
            ],
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            areas: 'registration_lists/country_areas',
            reload_content: 'common/reload_content',
            reward_types: 'registration_lists/reward_types',
            reward_categories: 'registration_lists/reward_categories',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        loadFilter() {
            if (this.$q.localStorage.has('dataTableSale')) {
                let historys = this.$q.localStorage.get.item('dataTableSale')
                this.server_pagination.rowsPerPage = historys.rowsPerPage
                this.filter = historys.filter
            }
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        fetchLists() {
            this.$q.loading.show()

            this.$axios.get('/accounts/get_registration_lists/', this.getHeader)
            .then(response => {
                this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        request ({ pagination }) {
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.savePagination()

            this.loading = true

            if (!this.user_id) {
                this.$axios.get(`/admin_rewards/rewards_orders/${this.id_redeem}/list_user_orders/?${this.$qs.stringify(data)}`, this.getHeader)
                .then(response => {
                    this.server_pagination.rowsNumber = response.data.count
                    this.redeem_history_list = response.data.results.map((e, index) => ({...e, actions:index}))
                    this.loading = false
                })
                .catch(e => {
                    this.loading = false
                    console.log(e)
                })
            }
            else {
                this.$axios.get(`/admin_rewards/users_reward_levels/${this.id_redeem}/user_orders/?${this.$qs.stringify(data)}`, this.getHeader)
                .then(response => {
                    this.server_pagination.rowsNumber = response.data.count
                    this.redeem_history_list = response.data.results.map((e, index) => ({...e, actions:index}))
                    this.loading = false
                })
                .catch(e => {
                    this.loading = false
                    console.log(e)
                })
            }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        getStatus(status) {
            if (status == 1) return 'awaiting_approval'
            else if (status == 2) return 'approved'
            else if (status == 3) return 'reproved'
            else if (status == 4) return 'shipped'
            else if (status == 5) return 'delivered'
            else return ''
        },

        getIconStatus(status) {
            if (status == 1) return 'fal fa-hourglass-half'
            else if (status == 2) return 'fal fa-check-double'
            else if (status == 3) return 'fal fa-times'
            else if (status == 4) return 'fal fa-shipping-fast'
            else if (status == 5) return 'fal fa-hand-holding-box'
            else return ''
        },

        getColorStatus(status) {
            if (status == 1) return 'amber'
            else if (status == 2) return 'positive'
            else if (status == 3) return 'negative'
            else if (status == 4) return 'orange'
            else if (status == 5) return 'light-green'
            else return ''
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm'
                    break
                    default: format = 'MM-DD-YYYY HH:mm'
                    break
                }

                return date.formatDate(d, format)
            }
        },

    },

    created() {
        this.id_redeem = this.$route.params.id
        this.loadFilter()
        this.loadPagination()
        this.fetchLists()
    }
}
</script>

<style>

</style>